module.exports = "../dist/img/product-detail-1-40.0614.jpg";